<!--
 * @Description: 打印条
 * @Author: zml
 * @Date: 2023-04-20 15:18:32
 * @LastEditors: xie
 * @LastEditTime: 2026-05-15 11:14:09
-->
<template>
  <div class="print" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search">
      <el-form ref="ruleForm" :inline="true" :model="queryParam" class="demo-form-inline">
        <el-form-item label="厂商编号:" prop="ma_Nu">
          <el-input
            style="width: 4rem;"
            ref="ma_Nu"
            v-model.trim="queryParam.ma_Nu"
            placeholder="请输入厂商编号"
            @focus="maNuFocus"
            @keydown.enter.native="getManufacturerInfo"
            @blur="onBlur"
          ></el-input>
          <el-button style="width:50px; border: none;" plain @click="showKeyboard('ma_Nu')">
            <i class="iconfont icon-jianpan" style="font-size:0.3rem"></i>
          </el-button>
        </el-form-item>
        <el-form-item label="厂商名称:" prop="ma_Na">
          <el-input style="width: 4rem;" v-model="queryParam.ma_Na" placeholder="厂商名称" disabled></el-input>
        </el-form-item>
        <el-form-item label="样品货号:" prop="fa_No">
          <el-input
            style="width: 3rem;"
            ref="fa_No"
            v-model.trim="queryParam.fa_No"
            placeholder="样品货号"
            @focus="faNoFocus"
            @keydown.enter.native="getManufacturerInfo"
          >
            <i slot="append" class="el-icon-close" style="font-size:0.25rem" @click="clearValue"></i>
          </el-input>
          <el-button style="width:50px; border: none;" plain @click="showKeyboard('fa_No')">
            <i class="iconfont icon-jianpan" style="font-size:0.3rem"></i>
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button style="background: #1890ff;color:#fff" @click="query">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onReset" style="color:#fff;">清空</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="center">
      <div class="sort">
        <div class="left">
          排序方式：
          <span :class="sortStatus === 1 ? 'active' : ''" @click="sortFun(1)">
            <span>出厂货号</span>
            <i class="el-icon-top" v-if="sortStatus ===1 && queryParam.sortOrder === 'ascending'"></i>
            <i class="el-icon-bottom" v-if="sortStatus ===1 && queryParam.sortOrder === 'descending'"></i>
          </span>
          <span :class="sortStatus === 2 ? 'active' : ''" @click="sortFun(2)" v-if="!isHidePrice">
            <span>价格</span>
            <i class="el-icon-top" v-if="sortStatus ===2 && queryParam.sortOrder === 'ascending'"></i>
            <i class="el-icon-bottom" v-if="sortStatus ===2 && queryParam.sortOrder === 'descending'"></i>
          </span>
          <span :class="sortStatus === 3 ? 'active' : ''" @click="sortFun(3)">
            <span>品名</span>
            <i class="el-icon-top" v-if="sortStatus ===3 && queryParam.sortOrder === 'ascending'"></i>
            <i class="el-icon-bottom" v-if="sortStatus ===3 && queryParam.sortOrder === 'descending'"></i>
          </span>
          <span :class="sortStatus === 4 ? 'active' : ''" @click="sortFun(4)">
            <span>装箱量</span>
            <i class="el-icon-top" v-if="sortStatus ===4 && queryParam.sortOrder === 'ascending'"></i>
            <i class="el-icon-bottom" v-if="sortStatus ===4 && queryParam.sortOrder === 'descending'"></i>
          </span>
          <span :class="sortStatus === 5 ? 'active' : ''" @click="sortFun(5)">
            <span>更新时间</span>
            <i class="el-icon-top" v-if="sortStatus ===5 && queryParam.sortOrder === 'ascending'"></i>
            <i class="el-icon-bottom" v-if="sortStatus ===5 && queryParam.sortOrder === 'descending'"></i>
          </span>
          <span @click="packClick">
            <span>包装筛选</span>
            <i class="el-icon-arrow-down"></i>
          </span>
        </div>
        <div class="right">
          <span v-if="queryParam.ma_Na">欢迎{{queryParam.ma_Na}}！</span>
          <span style="font-size:0.18rem;font-weight:400">技术支持：宏升云科技</span>
        </div>
      </div>
      <div class="items infinite-list-wrapper" v-infinite-scroll="load" style="overflow:auto" :infinite-scroll-disabled="disable">
        <div class="card-box" v-for="(item,index) in loadData" :key="index">
          <div :class="`card ${item._isCheck_ ? 'borders' : ''} infinite-list-item`">
            <div class="card-in" @click.stop="rowClick(item)">
              <div class="price">
                <div class="fa-no" :class="isHidePrice? 'hide-price': ''">{{item.fa_No}}</div>
                <div class="icon" v-if="!isHidePrice">/</div>
                <div class="prices" style="color:red;" v-if="!isHidePrice">￥{{item.fa_Pr}}</div>
              </div>
              <div class="title">{{item.pr_Na}}</div>
              <div class="num">{{item.in_En || 0}}/{{item.ou_Lo }}PCS | {{item.ch_Pa }}</div>
              <div class="wire"></div>
            </div>
            <div class="number">
              <el-input-number v-model="item._printSum_" :min="1" :max="1000" @change="onChange(item)"></el-input-number>
              <span class="unit">份</span>
            </div>
            <div class="select-ok" v-show="item._isCheck_ " @click.stop="rowClick(item)">
              <!-- <div class="cancel">点击取消</div> -->
              <div class="ok-icon">
                <div class="el-icon-check ok"></div>
              </div>
            </div>
          </div>
          <div v-if="isDom"></div>
        </div>
        <div v-if="loadData.length ===0" class="empty">{{ tenantInfo.cn_Name }} 欢迎您！</div>
      </div>
    </div>
    <div class="footer">
      <div class="left">
        <el-button class="btn1" style="margin:0 0.20rem 0 0" @click="selectAll">全选({{ selectionRows.length }})</el-button>
        <el-button class="btn2" style="margin:0 0.20rem 0 0" @click="selectInvert">反选</el-button>
        <el-button class="btn3" style="margin:0 0.20rem 0 0" @click="selectCancel">取消选择</el-button>
        <el-button type="danger" style="margin:0 0.28rem 0 0" @click="onReset">清空</el-button>
      </div>
      <div class="right">
        <span>共{{totalRows}}条记录</span>
        <div class="number">
          <el-input-number v-model="printNum" :min="1" :max="1000" @change="onChangeAll"></el-input-number>
          <span class="unit">份</span>
        </div>
        <el-button type="primary" :class="totalRows===0? '': ''" style="margin:0 0 0 0.20rem" @click="onPrint" :disabled="totalRows===0">打印</el-button>
        <el-button
          type="primary"
          :class="totalRows===0? '': ''"
          style="margin:0 0 0 0.20rem"
          @click="onPrint2"
          v-if="form.isOpenPrint2"
          :disabled="totalRows===0"
        >打印2</el-button>
      </div>
    </div>
    <el-dialog title="打印厂商样品条码设置" :visible.sync="dialogVisible" width="7rem" :show-close="false" center>
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-form-item label="限制层数" prop="isEnable">
          <el-checkbox v-model="form.isEnable" label="启用自助打印条码限制层数" @change="changeLayer"></el-checkbox>
        </el-form-item>
        <el-form-item label="层数编号" prop="layerNumber">
          <el-input v-model="form.layerNumber" />
        </el-form-item>
        <el-form-item label="隐藏价格">
          <el-checkbox v-model="isHidePrice">不在界面上显示价格</el-checkbox>
        </el-form-item>
        <el-form-item label="打印设置">
          <div style="display: flex; flex-direction: column;">
            <el-checkbox v-model="form.isNoOuSpec" label="外箱规格、外箱毛/净重不完整不允许打印"></el-checkbox>
            <el-checkbox v-model="form.isNoPrSpec" label="样品规格、样品毛/净重不完整不允许打印"></el-checkbox>
            <el-checkbox v-model="form.isNoImg" label="没有图片不允许打印"></el-checkbox>
            <el-checkbox v-model="form.isNoOu_Lo" label="装箱量为空不允许打印"></el-checkbox>
            <el-checkbox v-model="form.isNoPrSpec1 " label="样品规格不完整不允许打印"></el-checkbox>
            <el-checkbox v-model="form.isNoInSpec" label="包装规格不完整不允许打印"></el-checkbox>
            <el-checkbox v-model="form.isInHiSpec" label="包装高度为0允许打印"></el-checkbox>
            <el-checkbox v-model="form.isOpenPrint2" label="启用打印2"></el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="自动清空时间" prop="clearingTime">
          <el-input-number v-model="form.clearingTime" controls-position="right" :min="0"></el-input-number>
          <span style="margin-left: 8px;">秒</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveConfig">确 定</el-button>
      </span>
    </el-dialog>
    <simple-keyboard @onChange="onChangeKeyboard" @onKeyPress="onKeyPress" @close="closeKeyboard" :input="input" v-show="showVirtual"></simple-keyboard>
    <el-dialog title="包装方式" :visible.sync="packVisible" width="44%">
      <el-checkbox-group v-model="checkList" class="ck-list">
        <el-checkbox :label="item" v-for="(item, index) in packList" :key="index" class="ck-item">{{ item }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="handleOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  ProductBasicQueryPage,
  GetManufacturerInfo,
  decryptingQRcode,
  getExhibitionCode,
  getBarCodeReport,
  saveProductBarCodeReport,
  reportPrintFile,
  deletePrintCache,
  getIncompleteProductCount,
  getDefaultReport,
  decryptingHSQRcode,
  getPacks
} from '@/api/home'
import { mapState } from 'vuex'
import moment from 'moment'
import simpleKeyboard from '@/components/simpleKeyboard.vue'

var timer = null
var socketTimer = null
export default {
  components: {
    simpleKeyboard
  },
  data() {
    return {
      path: 'ws://127.0.0.1:11999',
      socket: "",
      printNum: 1,
      input: '',
      focusField: 'ma_Nu',
      fullscreenLoading: false,
      disable: false,
      loadData: [],
      // 查询参数
      queryParam: {
        pageNo: 1,
        pageSize: 200,
        sortField: 'fa_No',
        sortOrder: 'ascending', // 升ascending 降descending
        keywords: '',
        ma_Nu: '',
        ma_Na: '',
        fa_No: '',
        ch_Pas: []
      },
      form: {
        isEnable: false,
        layerNumber: '',
        isNoPrSpec: false,
        isNoOuSpec: false,
        isNoImg: false,
        isNoOu_Lo: false,
        isNoPrSpec1: false,
        isNoInSpec: false,
        isOpenPrint2: false,
        isInHiSpec: false,
        clearingTime: 60
      },
      isHidePrice: false,
      rules: {},
      dialogVisible: false,
      isDom: false,
      time: 60,
      showVirtual: false,
      showTime: false,
      totalPage: 0,
      totalRows: 0,
      sortStatus: 1,
      printLoading: null,
      // 选中的数据集
      selectionRows: [],
      printCode: '',
      exhibitionCode: '', // 展厅识别码
      isPass: false,
      oldMaNu: '',
      packVisible: false,
      packList: [],
      checkList: []
    }
  },
  computed: {
    ...mapState('tenant', ['tenantInfo'])
  },
  created() {
    this.initData()
    document.onselectstart = function () { return false }
  },
  mounted() {
    this.focusField = 'ma_Nu'
    this.$refs.ma_Nu.focus()
    this.init()
    const _this = this
    window.addEventListener('click', () => {
      _this.time = _this.form.clearingTime
    })

    window.addEventListener('keydown', (e) => {
      if (e.key === 'F9' && e.ctrlKey) {
        _this.dialogVisible = false
        _this.openDialog()
      }
    })
  },
  destroyed() {
    window.removeEventListener('click', () => { })
    window.removeEventListener('keydown', () => { })
    this.socket.onclose = () => { console.log('socket已经关闭') }
  },
  methods: {
    init() {
      const settingData = JSON.parse(localStorage.getItem('settings')) || {}
      this.form = Object.keys(settingData).length > 0 ? settingData : this.form
      this.isHidePrice = settingData.isHidePrice || false
      if (typeof (WebSocket) === 'undefined') {
        this.$message.warning('您的浏览器不支持socket，将无法使用打印功能')
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.path)
        this.socket.onopen = this.open
        this.socket.onerror = this.error
        this.socket.onmessage = this.getMessage
      }
    },
    onChangeKeyboard(input) {
      this.queryParam[this.focusField] = input
      setTimeout(() => {
        this.$refs[this.focusField].focus()
      }, 10)
    },
    onKeyPress(button) {
      if (button === '{enter}') {
        this.getManufacturerInfo()
      }
    },
    showKeyboard(type) {
      switch (type) {
        case 'ma_Nu':
          this.showVirtual = !this.showVirtual
          this.$refs.ma_Nu.focus()
          break
        case 'fa_No':
          this.showVirtual = !this.showVirtual
          this.$refs.fa_No.focus()
          break
      }
    },

    clearValue() {
      this.queryParam.fa_No = ''
      this.$refs.fa_No.focus()
    },
    // 厂商编号获取焦点
    maNuFocus() {
      this.input = this.queryParam.ma_Nu
      this.focusField = 'ma_Nu'
    },
    // 出厂货号获取焦点
    faNoFocus() {
      this.input = this.queryParam.fa_No
      console.log(this.input)
      this.focusField = 'fa_No'
    },
    // 关闭虚拟键盘
    closeKeyboard() {
      this.showVirtual = false
      this.$refs[this.focusField].focus()
    },
    load() {
      if (this.queryParam.ma_Nu === '') return
      this.queryParam.pageNo++
      this.queryData()
    },
    openDialog() {
      this.dialogVisible = true
    },
    changeLayer() {
      if (this.form.isEnable) {
        this.rules = { layerNumber: [{ required: true, message: '请输入层数编号', trigger: 'blur' }] }
      } else {
        this.rules = {}
        this.$refs.form.clearValidate('layerNumber')
      }
    },
    saveConfig() {
      this.dialogVisible = false
      this.$message.success('保存配置成功')
      let data = this.form
      data.isHidePrice = this.isHidePrice
      localStorage.setItem('settings', JSON.stringify(data))
    },
    // 连接socket
    open() {
      this.$message.success('打印服务连接成功')
      this.heartCheck()
    },
    // 连接错误
    error() {
      const _this = this

      // 清除心跳检测
      if (socketTimer) {
        clearInterval(socketTimer)
      }

      if (this.printLoading) {
        this.printLoading.close()
      }

      setTimeout(() => {
        _this.init()
      }, 5000)
    },
    // 监听消息
    getMessage(res) {
      if (res.data === 'ok' && this.printLoading) {
        this.printLoading.close()
        deletePrintCache({ code: this.printCode })
      } else if (res.data !== 'ok' && res.data.indexOf('Version') === -1) {
        this.$message.warning(res.data)
        this.printLoading.close()
      }
    },
    // socket心跳检测
    heartCheck() {
      if (socketTimer) {
        clearInterval(socketTimer)
      }
      const _this = this
      socketTimer = setInterval(() => {
        if (_this.socket.readyState !== 1) {
          _this.init()
        }
      }, 3000)
    },
    initData() {
      getExhibitionCode().then(res => {
        if (res.success) {
          this.exhibitionCode = res.data || ''
        } else {
          this.$message.error(JSON.stringify(res.message))
        }
      })
    },
    query() {
      if (!this.queryParam.ma_Nu) {
        this.$message.warning('请选输入厂商编号或摊位号')
        this.$refs[this.focusField].focus()
        return
      }

      if (this.queryParam.fa_No !== '') {
        this.oldMaNu = this.queryParam.ma_Nu
      } else {
        this.selectionRows = []
      }

      this.queryParam.pageNo = 1
      this.getManufacturerInfo()
    },
    async queryData() {
      let flag = 'confirm'
      if (this.form.isNoImg || this.form.isNoOuSpec || this.form.isNoOu_Lo || this.form.isNoPrSpec || this.form.isNoInSpec || this.form.isNoPrSpec1) {
        // 检查数量
        const result = await getIncompleteProductCount({
          ma_Nu: this.queryParam.ma_Nu,
          isNoImg: this.form.isNoImg,
          isNoOuSpec: this.form.isNoOuSpec,
          isNoPrSpec: this.form.isNoPrSpec,
          isNoOu_Lo: this.form.isNoOu_Lo,
          isNoPrSpec1: this.form.isNoPrSpec1,
          isNoInSpec: this.form.isNoInSpec
        })

        // 成功
        if (result.success) {
          if (result.data > 0 && !this.isPass) {
            flag = await this.$confirm(`当前存在${result.data}款样品，没有图片或包装规格，产品规格，毛重，净重不全，请到前台补齐！ 继续操作请点击继续操作，否则点击取消操作`, '系统提示', {
              confirmButtonText: '继续操作',
              cancelButtonText: '取消操作',
              type: 'warning'
            })
          }
        } else {
          this.$message.warning(result.message)
          return
        }
      }

      if (flag === 'confirm') {
        this.isPass = true
        // 是否启用严格模式
        this.queryParam.isNoImg = this.form.isNoImg
        this.queryParam.isNoOuSpec = this.form.isNoOuSpec
        this.queryParam.isNoOu_Lo = this.form.isNoOu_Lo
        this.queryParam.isNoPrSpec = this.form.isNoPrSpec
        this.queryParam.isNoInSpec = this.form.isNoInSpec
        this.queryParam.isNoPrSpec1 = this.form.isNoPrSpec1
        this.queryParam.isInHiSpec = this.form.isInHiSpec
        this.queryParam.ch_Pas = this.checkList
        this.fullscreenLoading = true
        ProductBasicQueryPage(this.queryParam).then(res => {
          if (res.success) {
            this.totalPage = res.data.totalPages || 0
            this.totalRows = res.data.totalCount || res.data.totalRows || 0

            if (this.loadData.length === 0 || this.queryParam.pageNo === 1) {
              this.loadData = res.data.items || res.data.rows || []
            } else {
              this.loadData = this.loadData.concat(res.data.items || res.data.rows)
            }

            if (this.loadData.length === this.totalRows || res.data.totalPage <= this.queryParam.pageNo) {
              this.disable = true
            } else {
              this.disable = false
            }

            this.loadData.forEach(item => {
              item._printSum_ = 1
              item._isCheck_ = false
              this.selectionRows.forEach(it => {
                if (item.id === it.id) {
                  item._isCheck_ = it._isCheck_
                  item._printSum_ = it._printSum_
                }
              })
            })

            const _this = this
            if (timer) {
              _this.time = _this.form.clearingTime
              clearInterval(timer)
            }

            _this.showTime = true
            timer = setInterval(() => {
              _this.time--
              if (_this.time <= 0) {
                _this.onReset()
                _this.time = _this.form.clearingTime
                _this.showTime = false
                clearInterval(timer)
              }
            }, 1000)
            _this.$refs.ma_Nu.focus()
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
          this.$message.error(err.message)
        }).finally(() => {
          this.fullscreenLoading = false
        })
      }
    },

    // 获取厂商名称
    async getManufacturerInfo() {
      if (!this.queryParam.ma_Nu) {
        this.$message.warning('请先输入厂商编号')
        this.$refs.ma_Nu.focus()
        return
      }

      if (this.queryParam.ma_Nu.length > 20 && this.queryParam.ma_Nu.indexOf('hsrj') === -1) {
        const result = await decryptingQRcode({ code: decodeURIComponent(this.queryParam.ma_Nu) })
        if (result.success) {
          const strArr = result.data.split(';')
          // 判断展厅识别码
          if (this.exhibitionCode !== strArr[5]) {
            this.queryParam.ma_Nu = ''
            this.$message.error('该二维码不是当前展厅，请出示当前展厅的厂商二维码')
            return
          }

          // 判断二维码有效期
          const qrCodeTime = moment(strArr[1])
          const systemTime = moment()
          if (qrCodeTime.isBefore(systemTime)) {
            this.queryParam.ma_Nu = ''
            this.$message.error('二维码已失效，请出示有效的二维码')
            return
          }

          this.queryParam.ma_Nu = strArr[3]
        } else {
          this.queryParam.ma_Nu = ''
          this.$message.error(JSON.stringify(result.message))
          return
        }
      }

      if (this.queryParam.ma_Nu.indexOf('hsrj') > -1) {
        const code = this.queryParam.ma_Nu.substring(this.queryParam.ma_Nu.indexOf('hsrj') + 4)
        const result = await decryptingHSQRcode({ code: code })
        if (result.success) {
          const strArr = result.data.split(',')
          // 判断展厅识别码
          if (this.tenantInfo.id != strArr[1]) {
            this.queryParam.ma_Nu = ''
            this.$message.error('该二维码不是当前展厅，请出示当前展厅的厂商二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          // 判断二维码有效期
          const qrCodeTime = moment(strArr[2])
          const systemTime = moment()
          if (qrCodeTime.isBefore(systemTime)) {
            this.queryParam.ma_Nu = ''
            this.$message.error('二维码已失效，请出示有效的二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          this.queryParam.ma_Nu = strArr[0]
        } else {
          this.queryParam.ma_Nu = ''
          this.$message.error(JSON.stringify(result.message))
          this.$refs.input.focus()
          return
        }
      }

      this.disable = false
      this.showVirtual = false
      this.focusField = 'ma_Nu'
      if (this.queryParam.fa_No !== '') {
        if (this.oldMaNu !== this.queryParam.ma_Nu) {
          this.selectionRows = []
          this.queryParam.fa_No = ''
        }
      } else {
        this.selectionRows = []
      }
      if (this.queryParam.ma_Nu) {
        GetManufacturerInfo({
          ma_Nu: this.queryParam.ma_Nu,
          isEnable: this.form.isEnable,
          layerNumber: this.form.layerNumber
        }).then(res => {
          if (res.success) {
            if (res.data) {
              this.queryParam.ma_Nu = res.data.ma_Nu
              this.queryParam.ma_Na = res.data.ma_Na
              this.queryParam.pageNo = 1
              this.oldMaNu = res.data.ma_Nu
              this.queryData()
            } else {
              this.queryParam.ma_Nu = ''
              this.$message.error('不存在的厂商信息，请输入正确的厂商编号或摊位号')
              this.$refs.ma_Nu.focus()
            }
          } else {
            this.queryParam.ma_Nu = ''
            this.$alert(JSON.stringify(res.message), '系统提示', {
              type: 'warning',
              confirmButtonText: '确定'
            })
          }
        })
      } else {
        this.queryParam.ma_Na = ''
      }
    },

    onBlur() {
      if (!this.isFocus) {
        this.isFocus = true
        const _this = this
        setTimeout(() => {
          _this.isFocus = false
          _this.$refs[this.focusField].focus()
        }, 10000)
      }
    },
    // 重置
    onReset() {
      if (timer) {
        this.showTime = false
        this.time = this.form.clearingTime
        clearInterval(timer)
      }
      this.$refs.ruleForm.resetFields()
      this.checkList = []
      this.disable = false
      this.queryParam.pageNo = 1
      this.totalPage = 0
      this.totalRows = 0
      this.loadData = []
      this.selectionRows = []
      this.sortStatus = 1
      this.focusField = 'ma_Nu'
      this.oldMaNu = ''
      this.isPass = false
      this.$refs.ma_Nu.focus()
    },

    // 排序方法
    sortFun(num) {
      if (!this.queryParam.ma_Nu) {
        this.$message.warning('请选输入厂商编号或摊位号')
        this.$refs.ma_Nu.focus()
        return
      }
      this.sortStatus = num
      switch (num) {
        case 1:
          this.queryParam.sortField = 'fa_No' // 出厂货号
          break
        case 2:
          this.queryParam.sortField = 'fa_Pr' // 价格
          break
        case 3:
          this.queryParam.sortField = 'ch_Pa' // 品名
          break
        case 4:
          this.queryParam.sortField = 'ou_Lo' // 装箱量
          break
        case 5:
          this.queryParam.sortField = 'updatedTime' // 更新时间
          break
      }
      this.queryParam.sortOrder = this.queryParam.sortOrder === 'ascending' ? 'descending' : 'ascending' // 赋值取反
      this.loadData = []
      this.queryParam.pageNo = 1
      this.queryData()
    },
    async packClick() {
      if (!this.queryParam.ma_Nu) {
        this.$message.warning('请先输入厂商编号')
        this.$refs.ma_Nu.focus()
        return
      }
      await this.getList()
      this.packVisible = true
    },
    async getList() {
      const result = await getPacks({
        ma_Nu: this.queryParam.ma_Nu,
        isNoImg: this.form.isNoImg,
        isNoOuSpec: this.form.isNoOuSpec,
        isNoPrSpec: this.form.isNoPrSpec,
        isNoOu_Lo: this.form.isNoOu_Lo,
        isNoPrSpec1: this.form.isNoPrSpec1,
        isNoInSpec: this.form.isNoInSpec,
        isInHiSpec: this.form.isInHiSpec
      })
      // 成功
      if (result.success) {
        this.packList = result.data || []
      } else {
        this.$message.warning(result.message)
        return
      }
    },
    async handleOk() {
      await this.queryData()
      await this.handleCancel()
    },
    reset() {
      this.checkList = []
    },
    handleCancel() {
      this.packVisible = false
    },
    // 单选
    rowClick(row) {
      this.loadData.forEach(item => {
        if (item.id === row.id) {
          item._isCheck_ = !row._isCheck_
          const indexs = this.selectionRows.findIndex(it => it.id === row.id)
          if (item._isCheck_) {
            this.selectionRows.push(item)
          } else {
            this.selectionRows.splice(indexs, 1)
          }
        }
        this.isDom = true
        this.$nextTick(() => {
          this.isDom = false
        })
      })
    },
    // 全选
    selectAll() {
      this.selectionRows = []
      this.loadData.forEach(item => {
        if (!item._isCheck_) {
          item._isCheck_ = true
        }
        this.selectionRows.push(item)
      })

      this.isDom = true
      this.$nextTick(() => {
        this.isDom = false
      })
    },
    // 反选
    selectInvert() {
      this.loadData.forEach(item => {
        item._isCheck_ = !item._isCheck_
        const indexs = this.selectionRows.findIndex(it => it.id === item.id)
        if (item._isCheck_) {
          this.selectionRows.push(item)
        } else {
          this.selectionRows.splice(indexs, 1)
        }
      })
      this.isDom = true
      this.$nextTick(() => {
        this.isDom = false
      })
    },
    // 取消选中
    selectCancel() {
      this.loadData.forEach(item => {
        item._isCheck_ = false
      })
      this.selectionRows = []
    },
    // 单选打印份数
    onChange(row) {
      const indexs = this.selectionRows.findIndex(it => it.id === row.id)
      if (indexs != -1) {
        this.selectionRows[indexs]._printSum_ = row._printSum_
      }
      this.isDom = true
      this.$nextTick(() => {
        this.isDom = false
      })
    },

    // 多选打印份数
    onChangeAll(currentValue, oldValue) {
      this.loadData.forEach(item => {
        this.selectionRows.forEach(it => {
          if (item.id === it.id) {
            item._printSum_ = currentValue
          }
          it._printSum_ = currentValue
        })
      })
      this.isDom = true
      this.$nextTick(() => {
        this.isDom = false
      })
    },

    // 打印
    async onPrint() {
      if (this.selectionRows.length === 0) {
        this.$message.warning('请先选择要打印的数据')
        return
      }

      if (this.socket.readyState !== 1) {
        this.$message.warning('打印服务未启动，请联系展厅工作人员')
        return
      }

      // 获取报表
      const report = await getBarCodeReport()
      if (!report.success) {
        this.$message.warning('暂未设置打印报表，请联系展厅工作人员')
        return
      }

      // 额外参数
      const prodcutPairs = this.selectionRows.map((item) => {
        return { co_Nu: item.co_Nu, num: item._printSum_ }
      })

      // 打印参数
      const reportParam = {
        dataIds: this.selectionRows.map((item) => { return item.id }),
        reportId: report.data,
        sortField: this.queryParam.sortField,
        sortOrder: this.queryParam.sortOrder,
        prodcutPairs
      }

      const result = await saveProductBarCodeReport(reportParam)
      if (result.success) {
        this.printLoading = this.$loading({
          lock: true,
          text: '正在生成文件，请耐心等待',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        reportPrintFile({ code: result.data, tenantId: this.tenantInfo.id }).then(res => {
          this.printCode = result.data
          const objData = {
            type: 0,
            message: res.data
          }
          this.socket.send(JSON.stringify(objData))
        }).catch(() => {
          this.fullscreenLoading = false
          this.printLoading.close()
        })
      }
    },
    // 打印2
    async onPrint2() {
      if (this.selectionRows.length === 0) {
        this.$message.warning('请先选择要打印的数据')
        return
      }

      if (this.socket.readyState !== 1) {
        this.$message.warning('打印服务未启动，请联系展厅工作人员')
        return
      }

      // 获取报表
      const report = await getDefaultReport()
      if (!report.success) {
        this.$message.warning('暂未设置默认打印报表，请联系展厅工作人员')
        return
      }

      // 额外参数
      const prodcutPairs = this.selectionRows.map((item) => {
        return { co_Nu: item.co_Nu, num: item._printSum_ }
      })

      // 打印参数
      const reportParam = {
        dataIds: this.selectionRows.map((item) => { return item.id }),
        reportId: report.data,
        sortField: this.queryParam.sortField,
        sortOrder: this.queryParam.sortOrder,
        prodcutPairs
      }

      const result = await saveProductBarCodeReport(reportParam)
      if (result.success) {
        this.printLoading = this.$loading({
          lock: true,
          text: '正在生成文件，请耐心等待',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        reportPrintFile({ code: result.data, tenantId: this.tenantInfo.id }).then(res => {
          this.printCode = result.data
          const objData = {
            type: 0,
            message: res.data
          }
          this.socket.send(JSON.stringify(objData))
        }).catch(() => {
          this.fullscreenLoading = false
          this.printLoading.close()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 40px;
  height: 50px;
}
::-webkit-scrollbar-thumb {
  background: #1890ff;
  box-shadow: 0 0 5px #fff;
}
:deep .el-dialog__body {
  text-align: left !important;
}

.empty {
  width: 100%;
  height: calc(100vh - 3.6rem);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  color: #d9e1f5;
}

.print {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: MicrosoftYaHei;

  .search {
    display: flex;
    align-items: center;
    min-height: 1.1rem;
    // height: 10%;
    padding: 0 0.3rem;

    .el-form {
      display: flex;
      width: 100%;
    }

    ::v-deep .el-input-group__append {
      padding: 0 !important;
      cursor: pointer;
    }

    :deep .el-form-item {
      display: flex;
      align-items: center;
      margin: 0 0.2rem 0 0;

      .el-form-item {
        display: flex;
        align-items: center;
      }

      .el-form-item__label {
        font-size: 0.18rem !important;
        color: #222222;
      }
      .el-form-item__content {
        display: flex;
        align-items: center;
      }
      .el-input__inner {
        font-size: 0.18rem !important;
        height: 0.4rem !important;
        line-height: 0.4rem !important;
        color: #8a8a8a;
      }
      button {
        height: 0.4rem !important;
        line-height: 0.4rem;
        padding: 0;
        font-size: 0.18rem !important;
        width: 1rem;
        color: #848484;
      }
    }
  }

  .center {
    flex: 1;
    background-color: #ecf2fe;
    .sort {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 0.68rem;
      padding: 0 0.4rem;
      margin-bottom: 0.1rem;
      box-shadow: 0px 0px 1px #333;
      .left {
        display: flex;
        width: 6rem;
        font-size: 0.18rem;
        color: #666666;
        font-weight: 600;
        & > span {
          display: flex;
          align-items: center;
          padding: 0 0.2rem 0 0;
          cursor: pointer;
          &:hover {
            color: #1890ff;
          }
          .el-icon-top,
          .el-icon-bottom {
            display: inline-block;
            font-size: 0.2rem;
            margin: 0.03rem 0 0 0;
            font-weight: 700;
          }
        }
        .active {
          color: #1890ff;
        }
      }
      .right {
        color: #222222;
        font-size: 0.24rem;
      }
    }
    .items {
      height: calc(100vh - 2.8rem);
      flex: 1;
      display: flex;
      flex-wrap: wrap;

      align-content: flex-start;
      padding: 0 0 0 0.1rem;
      .card-box {
        width: 16.6%;
        height: 1.82rem;
        padding: 0 0.1rem 0 0;
        margin-bottom: 0.1rem;
        box-sizing: border-box;

        .card {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          background-color: #fff;
          border-radius: 0.08rem;
          overflow: hidden;
          .card-in {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            cursor: pointer;
          }

          &.borders {
            border: 0.02rem solid #1890ff;
          }

          .select-ok {
            position: absolute;
            top: 0;
            right: 0;
            display: flex;
            cursor: pointer;
            .cancel {
              position: absolute;
              top: 0.1rem;
              right: 0.32rem;
              width: 0.6rem;
              height: 0.16rem;
              font-size: 0.12rem;
              font-family: MicrosoftYaHei;
              text-align: left;
              color: #c5752e;
              border: 0.01rem solid #c5752e;
              text-align: center;
              border-radius: 0.06rem 0 0.06rem 0.06rem;
              cursor: pointer;
            }

            .ok-icon {
              color: #fff;
              border-bottom: 0.14rem solid #fff;
              border-left: 0.3rem solid #fff;
              border-right: 0.2rem solid #1890ff;
              border-top: 0.2rem solid #1890ff;

              .ok {
                position: absolute;
                top: 0.01rem;
                right: 0.03rem;
              }
            }
          }

          .price {
            width: 80%;
            display: flex;
            justify-content: center;
            font-size: 0.2rem;
            color: #222222;
            font-weight: bold;
            margin: 0.1rem 0 0 0;
            .fa-no {
              width: 100%;
              display: inline-block;
              text-align: right;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .hide-price {
              text-align: center !important;
            }

            .icon {
              width: 0.1rem;
              margin: 0 0.05rem;
            }

            .prices {
              width: 100%;
            }
          }

          .title {
            width: 80%;
            text-align: center;
            height: 0.2rem;
            line-height: 0.2rem;
            font-size: 0.15rem;
            color: #222222;
            margin: 0.03rem 0 0 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .num {
            font-size: 0.15rem;
            color: #666666;
            margin: 0.03rem 0 0 0;
          }

          .wire {
            margin: 0.08rem 0 0.08rem 0;
            width: 90%;
            height: 0.01rem;
            border-bottom: 0.01rem dotted #dfdfdf;
          }
          .number {
            display: flex;
            align-items: center;
            margin: 0 -0.26rem 0.01rem 0;
            :deep .el-input-number {
              width: 1.44rem;
              line-height: 0.36rem;
              border-radius: 0.22rem;
              .el-input__inner,
              .el-input {
                border-radius: 0.22rem;
                height: 0.4rem !important;
                line-height: 0.4rem !important;
                font-size: 0.14rem;
                padding: 0;
              }
              .el-input__inner {
                border-radius: 0.22rem;
                border: #1890ff solid 0.01rem;
              }
              .el-input-number__increase,
              .el-input-number__decrease {
                border: none;
                border-radius: 0.22rem;
                height: 0.3rem;
                color: #1890ff;
                top: 0.05rem;
                font-size: 0.18rem;
                background-color: #fff;
                width: 0.4rem !important;
                background-color: none;
                padding: 0 0.1rem;
                margin: 0 0.02rem;
                box-sizing: border-box;
                display: flex;
                align-items: center;
              }
            }
            .unit {
              font-size: 0.2rem;
              color: #1890ff;
              padding: 0 0 0 0.1rem;
            }
          }
        }
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 98;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.2rem;
    height: 0.94rem;
    // height: 9%;
    // height: calc(100% - 2rem);
    background-color: #fff;
    .left {
      button {
        min-width: 1.64rem;
        height: 0.54rem;
        line-height: 0.54rem;
        padding: 0;
        font-size: 0.24rem;
        color: #fff;
        box-sizing: border-box;
        font-family: MicrosoftYaHei;
      }

      .btn1 {
        background-color: #56a5f8;
      }
      .btn2 {
        background-color: #6b91e3;
      }
      .btn3 {
        background-color: #df8481;
      }
    }

    .right {
      display: flex;
      align-items: center;
      & > span {
        font-size: 0.2rem;
        letter-spacing: 0.02rem;
        color: #666666;
        margin-right: 0.2rem;
      }

      button {
        min-width: 1.64rem;
        height: 0.54rem;
        line-height: 0.54rem;
        padding: 0;
        font-size: 0.24rem;
        color: #fff;
        box-sizing: border-box;
        font-family: MicrosoftYaHei;
      }
      .btn4 {
        background-color: #1890ff;
      }
      .number {
        display: flex;
        align-items: center;
        :deep .el-input-number {
          width: 1.44rem;
          border-radius: 0.22rem;
          .el-input__inner,
          .el-input {
            border-radius: 0.22rem;
            height: 0.4rem !important;
            line-height: 0.4rem !important;
            font-size: 0.14rem;
            padding: 0;
          }
          .el-input__inner {
            border-radius: 0.22rem;
            border: #1890ff solid 0.01rem;
          }
          .el-input-number__increase,
          .el-input-number__decrease {
            border: none;
            border-radius: 0.22rem;
            height: 0.3rem;
            color: #1890ff;
            top: 0.05rem;
            font-size: 0.18rem;
            background-color: #fff;
            width: 0.4rem !important;
            background-color: none;
            padding: 0 0.1rem;
            margin: 0 0.02rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
          }
        }
        .unit {
          font-size: 0.2rem;
          color: #1890ff;
          padding: 0 0 0 0.1rem;
        }
      }
    }
  }

  .page-btn {
    position: fixed;
    right: 0;
    top: 60%;
    .page-down,
    .page-up {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.34rem;
      height: 0.98rem;
      font-size: 0.14rem;
      font-family: MicrosoftYaHei;
      background: #10bda8;
      color: #fff;
      border-radius: 0.06rem 0 0 0.06rem;
      cursor: pointer;
      &:hover {
        background: #1890ff;
      }
    }
    .page-down {
      margin: 0.1rem 0 0 0;
    }
  }
}
.ck-list {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 30px;
  width: 100%;
  & .ck-item {
    width: 23.2%;
    line-height: 40px;
    box-sizing: border-box;
    :deep .el-checkbox {
      margin: 0;
      width: 100%;
    }
    :deep .el-checkbox__inner {
      width: 24px;
      height: 24px;
    }
    :deep .el-checkbox__label {
      font-size: 16px;
    }
  }
  :deep .el-checkbox {
    margin-right: 14px;
  }
  :deep .el-checkbox__inner::after {
    width: 10px;
    height: 14px;
    top: 0px;
    left: 5px;
  }
}
</style>